require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./button"), require("./flexlayout"), require("./list"), require("./itemdnd"), require("./draglayer"), require("./hspacer"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./button", "./flexlayout", "./list", "./itemdnd", "./draglayer", "./hspacer"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./button"), require("./flexlayout"), require("./list"), require("./itemdnd"), require("./draglayer"), require("./hspacer")) : factory(root["./utils"], root["./button"], root["./flexlayout"], root["./list"], root["./itemdnd"], root["./draglayer"], root["./hspacer"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__22__, __WEBPACK_EXTERNAL_MODULE__45__, __WEBPACK_EXTERNAL_MODULE__90__, __WEBPACK_EXTERNAL_MODULE__91__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[71],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__12__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__14__;

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-treeItem__button{position:relative}.ba-common-treeItem .ba-common-listItem-with-right-icon .ba-common-button.is-small .ba-common-svgIcon.is-small.is-pad{padding-left:16px;padding-right:16px}.ba-common-treeItem__child-item{padding:0}[dir=ltr].ba-common-treeItem__child-item{padding-right:8px}[dir=rtl].ba-common-treeItem__child-item{padding-right:0;padding-left:8px}[dir=ltr] .ba-common-treeItem__child-item,.ba-common-treeItem__child-item{padding-right:8px}[dir=rtl] .ba-common-treeItem__child-item{padding-right:0;padding-left:8px}.ba-common-treeItem__child-item .ba-common-svgIcon.is-small{min-width:16px}.ba-common-treeItem button[data-tid=expandTreeItemClickable]{border-color:transparent !important;color:inherit;outline:none !important}.ba-common-treeItem button[data-tid=expandTreeItemClickable] span,.ba-common-treeItem button[data-tid=expandTreeItemClickable] div{display:none !important}.ba-common-treeItem button[data-tid=expandTreeItemClickable]::before{display:none !important}.mobile .ba-common-treeItem__button.is-tiny{width:18px;height:18px}.ba-common-treeItem .ba-common-svgIcon{transition-duration:0s}", ""]);

// exports
exports.locals = {
	"treeItemClassName": "\"ba-common-treeItem\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__22__;

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__45__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(583);


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Tree = _interopRequireDefault(__webpack_require__(584));

exports.default = _Tree.default;
exports.Tree = _Tree.default;

var _treeDnD = _interopRequireWildcard(__webpack_require__(585));

exports.treeDnD = _treeDnD.default;
exports.treeItemDnD = _treeDnD.treeItemDnD;

var _TreeItem = _interopRequireDefault(__webpack_require__(586));

exports.TreeItem = _TreeItem.default;

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _list = _interopRequireWildcard(__webpack_require__(22));

var _utils = __webpack_require__(5);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  sortBy,
  forOwn,
  findIndex
} = _utils.lodash;
const {
  multiSelect,
  singleSelect
} = _utils.listHelper;
const {
  sanitize,
  getInheritedProps
} = _utils.propsUtils;

function purge(byIdData, byIdMap) {
  forOwn(byIdData, (v, key) => {
    if (!byIdMap[key]) {
      delete byIdData[key];
    }
  });
}

function toBoolMap(byIdObjects) {
  return Object.keys(byIdObjects).reduce((map, id) => {
    map[id] = !!byIdObjects[id];
    return map;
  }, {});
}

function computePathToRoot(node) {
  let result = '';
  let p = node;

  do {
    result = result ? `${p.relativeIndex}_${result}` : `${p.relativeIndex}`;
    p = p.parent;
  } while (p);

  return result;
}

class Tree extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      filterCollapsedNodes: {},
      active: this.props.activeNode ? this.props.getId(this.props.activeNode) : null
    });
    (0, _defineProperty2.default)(this, "getOrderedSelectedNodes", (selectedNodes = this.state.selectedNodes) => {
      const selectedMap = this._toObjectMap(selectedNodes);

      return sortBy(Object.keys(selectedMap), id => this._byIdMap[id].index).map(id => selectedMap[id]);
    });
    (0, _defineProperty2.default)(this, "getSelectedNodes", () => {
      const selectedMap = this._toObjectMap(this.state.selectedNodes);

      return Object.keys(selectedMap).map(id => selectedMap[id]);
    });
    (0, _defineProperty2.default)(this, "_activeIndex", -1);
    (0, _defineProperty2.default)(this, "_pivotIndex", -1);
    (0, _defineProperty2.default)(this, "_lastClickIndex", -1);
    (0, _defineProperty2.default)(this, "_byIdMap", {});
    (0, _defineProperty2.default)(this, "_data", []);
    (0, _defineProperty2.default)(this, "_prevExpandedNodes", {});
    (0, _defineProperty2.default)(this, "_flattenTree", true);
    (0, _defineProperty2.default)(this, "_getParentIndex", index => {
      const id = this._getId(index);

      const {
        parent
      } = this._byIdMap[id];

      if (!parent) {
        return -1;
      }

      return this._data.indexOf(parent);
    });
    (0, _defineProperty2.default)(this, "_isExpandedByIndex", index => {
      const {
        filter
      } = this.props;
      const {
        filterCollapsedNodes
      } = this.state;

      const id = this._getId(index);

      return filter ? !filterCollapsedNodes[id] : this._isExpandedById(id);
    });
    (0, _defineProperty2.default)(this, "_isExpandedById", id => {
      const {
        expandedByDefault
      } = this.props;
      const {
        expandedNodes
      } = this.state;
      return expandedByDefault ? !Object.prototype.hasOwnProperty.call(expandedNodes, id) || expandedNodes[id] : expandedNodes[id];
    });
    (0, _defineProperty2.default)(this, "_isSelected", index => this.state.selectedNodes[this._getId(index)]);
    (0, _defineProperty2.default)(this, "_itemRenderer", (index, props) => {
      const treeNode = this._data[index];
      const {
        focusDepth,
        hasChildren,
        alwaysExpanded,
        visible,
        node
      } = treeNode;

      const expanded = this._isExpandedByIndex(index);

      const {
        itemRenderer,
        data,
        focusNode,
        filter
      } = this.props;
      const treeProps = { ...props,
        node,
        hasChildren,
        alwaysExpanded,
        depth: focusDepth,
        expanded,
        visible,
        data,
        pathToRoot: computePathToRoot(treeNode),
        isFocusNode: !filter && focusNode && focusNode === node
      };
      return itemRenderer(node, treeProps);
    });
    (0, _defineProperty2.default)(this, "_onActiveChange", event => {
      this.setState(() => {
        const {
          index,
          type
        } = event;
        const {
          onActiveChange
        } = this.props;
        let newState;

        if (type === _list.activeEventTypes.ABSOLUTE) {
          const active = this._getId(index);

          newState = {
            active
          };
        } else {
          const delta = type === _list.activeEventTypes.UP ? -1 : 1;

          const active = this._getId(this._activeIndex + delta);

          newState = {
            active
          };
        }

        onActiveChange && onActiveChange(newState.active ? this._byIdMap[newState.active].node : null);
        return newState;
      });
    });
    (0, _defineProperty2.default)(this, "_onMenu", (x, y, e) => this.props.onMenu(x, y, this._toObjectMap(this.state.selectedNodes), e));
    (0, _defineProperty2.default)(this, "_onExpand", event => {
      const {
        index,
        type
      } = event;
      const {
        onExpand,
        data,
        filter
      } = this.props;
      const treeNode = this._data[index];
      const activeNode = this._byIdMap[this.state.active];
      const {
        id
      } = treeNode;
      let expanded;

      if (type === _list.expandEventTypes.TOGGLE) {
        expanded = !this.state.expandedNodes[id];
      } else if (type === _list.expandEventTypes.EXPAND) {
        expanded = true;
      } else if (type === _list.expandEventTypes.COLLAPSE) {
        expanded = false;
      }

      if (!expanded && activeNode) {
        let inHierarchy = false;
        let node = activeNode;

        while (node && !inHierarchy) {
          inHierarchy = node.parent === treeNode;
          node = node.parent;
        }

        if (inHierarchy) {
          this.setState({
            active: id,
            pivot: id,
            lastClick: id
          });
        }
      }

      const expandedNodes = { ...this.state.expandedNodes,
        [id]: expanded
      };
      const filterCollapsedNodes = { ...this.state.filterCollapsedNodes,
        [id]: !expanded
      };

      if (!this.props.expandedNodes) {
        this.setState({
          expandedNodes,
          filterCollapsedNodes
        });
      } else if (filter) {
        this.setState({
          filterCollapsedNodes
        });
      }

      onExpand && onExpand(expandedNodes, [treeNode.node], expanded, data);
    });
    (0, _defineProperty2.default)(this, "_onSelectionChange", event => {
      const {
        data,
        filter,
        selectionMode
      } = this.props;
      const {
        selectedNodes
      } = this.state;
      let selectedMap = {};

      if (selectionMode === 'single') {
        const key = singleSelect(event, this._data, Object.keys(selectedNodes)[0], this._getId);

        if (key != null) {
          selectedMap = {
            [key]: true
          };
        }
      } else {
        selectedMap = multiSelect(event, this._data, selectedNodes, this._getId).selectedMap;
      }

      if (!this.props.selectedNodes) {
        this.setState({
          selectedNodes: toBoolMap(selectedMap)
        });
      }

      if (filter) {
        const nodes = [];
        const expandedNodes = { ...this.state.expandedNodes
        };
        Object.keys(selectedMap).forEach(id => {
          let node = this._byIdMap[id].parent;

          while (node) {
            if (!expandedNodes[node.id]) {
              expandedNodes[node.id] = true;
              nodes.push(node);
            }

            node = this._byIdMap[node.id].parent;
          }
        });

        if (nodes.length) {
          if (!this.props.expandedNodes) {
            this.setState({
              expandedNodes
            });
          }

          const {
            onExpand
          } = this.props;
          onExpand && onExpand(expandedNodes, nodes.map(n => n.node), true, data);
        }
      }

      if (event.pivot && event.index !== -1) {
        this.setState({
          pivot: this._getId(event.index)
        });
      }

      if (event.last != null) {
        this.setState({
          lastClick: this._getId(event.last)
        });
      }

      const {
        onSelectionChange
      } = this.props;
      onSelectionChange && onSelectionChange(this._toObjectMap(selectedMap), this.getOrderedSelectedNodes(selectedMap), data);
    });
    (0, _defineProperty2.default)(this, "_refList", list => {
      this._list = list;
    });
    (0, _defineProperty2.default)(this, "_getIndex", id => id == null ? -1 : findIndex(this._data, treeNode => id === treeNode.id));
    (0, _defineProperty2.default)(this, "_getId", index => this._data[index] ? this._data[index].id : null);
    (0, _defineProperty2.default)(this, "_itemSizeEstimator", (index, cache) => this.props.itemSizeEstimator(this._data[index].node, index, cache));
    (0, _defineProperty2.default)(this, "_itemSizeGetter", index => this.props.itemSizeGetter(this._data[index].node, index));
  }

  componentWillMount() {
    const {
      defaultSelectedNodes,
      selectedNodes,
      defaultExpandedNodes,
      expandedNodes
    } = this.props;
    const selected = toBoolMap(selectedNodes || defaultSelectedNodes || {});
    const expanded = toBoolMap(expandedNodes || defaultExpandedNodes || {});
    this.setState({
      expandedNodes: expanded,
      selectedNodes: selected
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      filter,
      selectedNodes,
      expandedNodes,
      activeNode,
      isDragging
    } = nextProps;
    const newState = {};

    if (filter !== this.props.filter) {
      newState.filterCollapsedNodes = {};
    }

    if (selectedNodes) {
      newState.selectedNodes = toBoolMap(selectedNodes);
    }

    if (expandedNodes) {
      newState.expandedNodes = toBoolMap(expandedNodes);
    }

    if (activeNode) {
      newState.active = this.props.getId(activeNode);
    }

    if (isDragging) {
      this._flattenTree = false;
    }

    this.setState(newState);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.expandedNodes !== this.state.expandedNodes) {
      Object.keys(nextState.expandedNodes).forEach(id => {
        this._prevExpandedNodes[id] = true;
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const byIdMap = this._byIdMap;
    const {
      expandedNodes,
      filterCollapsedNodes,
      selectedNodes
    } = this.state;
    purge(this._prevExpandedNodes, byIdMap);
    purge(selectedNodes, byIdMap);
    purge(expandedNodes, byIdMap);
    purge(filterCollapsedNodes, byIdMap);

    if (prevState.active !== this.state.active) {
      this._list.scrollAround(this._activeIndex);
    }
  } // returns the nodes in the order in which they appear in the tree


  _toFlat(nodes, byIdMap, flatData, depth = 0, focusDepth = 0, startingIndex = 0, parent = null, isFocusChild = false) {
    const {
      getId,
      getChildren,
      getHasChildren,
      isVisible,
      filter,
      isAlwaysExpanded,
      focusNode
    } = this.props;
    const {
      filterCollapsedNodes
    } = this.state;
    const prevExpandedNodes = this._prevExpandedNodes;
    let index = startingIndex;

    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      const id = getId(node);
      let hasChildren;
      let children;

      if (getHasChildren) {
        hasChildren = getHasChildren(node, depth, focusDepth);
      } else {
        children = getChildren(node, depth, focusDepth);
        hasChildren = !!(children && children.length);
      }

      const alwaysExpanded = isAlwaysExpanded(node, depth, i, nodes.length, focusDepth);
      const treeNode = {
        relativeIndex: i,
        node,
        id,
        depth,
        focusDepth,
        index,
        parent,
        hasChildren,
        visible: true,
        alwaysExpanded
      };
      index += 1;
      byIdMap[id] = treeNode;

      if (filter) {
        const visible = isVisible(filter, node);
        treeNode.visible = isVisible(filter, node);

        if (hasChildren) {
          children = children || getChildren(node, depth, focusDepth) || [];
          const flatChildren = [];

          this._toFlat(children, byIdMap, flatChildren, depth + 1, depth + 1, index, treeNode);

          index += flatChildren.length;
          const filterCollapsed = filterCollapsedNodes[id];

          if (flatChildren.length || visible) {
            flatData.push(treeNode);
          }

          if (flatChildren.length && !filterCollapsed) {
            flatData.push(...flatChildren);
          }
        } else if (visible) {
          flatData.push(treeNode);
        }
      } else {
        const inFocus = !focusNode || focusNode === node || isFocusChild;

        if (flatData && inFocus) {
          flatData.push(treeNode);
        }

        if (hasChildren) {
          const expanded = this._isExpandedById(id) || alwaysExpanded;
          const prevExpanded = prevExpandedNodes[id];

          if (expanded || prevExpanded) {
            children = children || getChildren(node, depth, focusDepth) || []; // If we were previously expanded we need to go down this path in order to generate the byIdMap
            // to fully purge data that is no longer accessible.
            // `null` is passed in for `flatData` so that we do not actually add nodes to your flat data.

            const length = flatData ? flatData.length : 0;

            this._toFlat(children, byIdMap, expanded ? flatData : null, depth + 1, focusDepth + (inFocus ? 1 : 0), index, treeNode, inFocus);

            index += flatData ? flatData.length - length : 0;
          }
        }
      }
    }
  }

  _toObjectMap(boolMap) {
    return Object.keys(boolMap).reduce((map, id) => {
      if (boolMap[id] && this._byIdMap[id]) {
        map[id] = this._byIdMap[id].node;
      }

      return map;
    }, {});
  }

  scrollToId(id) {
    const index = this._getIndex(id);

    this._list.scrollTo(index);
  }

  render() {
    const {
      onMenu,
      data,
      getRootNodes,
      className,
      style,
      filter,
      emptyFilterState,
      itemSizeGetter,
      itemSizeEstimator,
      maxHeight,
      allowReorder,
      ...others
    } = this.props; // Try reduce the number calls to _toFlat() https://jsw.ibm.com/browse/MUI-1489

    if (allowReorder || this._flattenTree) {
      this._data = [];
      this._byIdMap = {};

      this._toFlat(getRootNodes(data), this._byIdMap, this._data);
    }

    this._flattenTree = true;
    this._activeIndex = this._getIndex(this.state.active);
    this._pivotIndex = this._getIndex(this.state.pivot);
    this._lastClickIndex = this._getIndex(this.state.lastClick);
    const listPassthroughProps = getInheritedProps(others, _list.default);

    if (emptyFilterState && filter && this._data.length === 0) {
      return emptyFilterState;
    }

    return /*#__PURE__*/_react.default.createElement(_list.default, (0, _extends2.default)({
      virtualized: true,
      "data-tid": "ba-tree__list"
    }, sanitize(others, Tree), listPassthroughProps, {
      ref: this._refList,
      activeIndex: this._activeIndex,
      pivotIndex: this._pivotIndex,
      lastClickIndex: this._lastClickIndex,
      length: this._data.length,
      onExpand: this._onExpand,
      getParentIndex: this._getParentIndex,
      role: "tree",
      itemRenderer: this._itemRenderer,
      isExpanded: this._isExpandedByIndex,
      onMenu: onMenu && this._onMenu,
      onSelectionChange: this._onSelectionChange,
      isSelected: this._isSelected,
      onActiveChange: this._onActiveChange,
      getKey: this._getId,
      getItemId: this._getId,
      hierarchical: true,
      className: className,
      style: {
        maxHeight,
        ...style
      },
      itemSizeEstimator: itemSizeEstimator && this._itemSizeEstimator,
      itemSizeGetter: itemSizeGetter && this._itemSizeGetter,
      selectionMark: true
    }));
  }

}

exports.default = Tree;
(0, _defineProperty2.default)(Tree, "propTypes", { ...sanitize(_list.default.propTypes, null, 'length'),
  onActiveChange: _propTypes.default.func,
  getChildren: _propTypes.default.func.isRequired,
  getId: _propTypes.default.func.isRequired,
  getRootNodes: _propTypes.default.func,
  getHasChildren: _propTypes.default.func,
  onExpand: _propTypes.default.func,
  isVisible: _propTypes.default.func,
  isAlwaysExpanded: _propTypes.default.func,
  onSelectionChange: _propTypes.default.func,
  onMenu: _propTypes.default.func,
  filter: _propTypes.default.string,
  data: _propTypes.default.any.isRequired,
  selectedNodes: _propTypes.default.object,
  defaultSelectedNodes: _propTypes.default.object,
  expandedNodes: _propTypes.default.object,
  defaultExpandedNodes: _propTypes.default.object,
  selectionMode: _propTypes.default.oneOf(['none', 'disabled', 'single', 'multi']),
  activeNode: _propTypes.default.any,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  emptyFilterState: _propTypes.default.node,
  expandedByDefault: _propTypes.default.bool,
  allowReorder: _propTypes.default.bool,
  isDragging: _propTypes.default.bool,
  focusNode: _propTypes.default.object,
  itemSizeGetter: _propTypes.default.func,
  itemSizeEstimator: _propTypes.default.func,

  /** Specifies the maximum height of the tree */
  maxHeight: _propTypes.default.number
});
(0, _defineProperty2.default)(Tree, "defaultProps", {
  getRootNodes: nodes => Array.isArray(nodes) ? nodes : [nodes],
  getChildren: node => node.children,
  getId: node => node.id,
  isAlwaysExpanded: () => false,
  isVisible: () => true,
  className: '',
  style: {}
});

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = _default;
exports.treeItemDnD = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _reactDnd = __webpack_require__(23);

var _draglayer = _interopRequireDefault(__webpack_require__(90));

var _itemdnd = _interopRequireWildcard(__webpack_require__(45));

var _utils = __webpack_require__(5);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const treeItemDnD = (TreeItem, itemType = _itemdnd.ITEM_TYPE) => {
  const options = typeof itemType === 'string' ? {
    dragItemType: itemType,
    dropItemType: itemType
  } : itemType;
  return (0, _itemdnd.default)(TreeItem, options);
};

exports.treeItemDnD = treeItemDnD;
const {
  omit
} = _utils.lodash;
const dropTargetMethods = {
  canDrop(props, monitor) {
    if (props.canDrop && (monitor.isOver({
      shallow: true
    }) || props.canFallThrough && props.canFallThrough())) {
      return props.canDrop({
        data: props.data
      }, monitor.getItem(), monitor);
    }

    return false;
  },

  hover() {},

  drop(props, monitor) {
    if (props.onDrop && !monitor.didDrop()) {
      props.onDrop({
        data: props.data
      }, monitor.getItem(), monitor);
    }
  }

};

function _default(Tree, itemType = _itemdnd.ITEM_TYPE, TreeDragLayer = _draglayer.default) {
  var _dec, _class, _class2, _temp;

  const ScrollableTree = (0, _itemdnd.scrollableDnD)(Tree);
  let TreeDnD = (_dec = (0, _reactDnd.DropTarget)(itemType, dropTargetMethods, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isActive: () => monitor.isOver() && monitor.canDrop(),
    getDragPosition: () => monitor.getClientOffset()
  })), _dec(_class = (_temp = _class2 = class TreeDnD extends _react.Component {
    constructor(...args) {
      super(...args);
      (0, _defineProperty2.default)(this, "state", {
        draggingNodes: []
      });
      (0, _defineProperty2.default)(this, "_connectToDnD", ref => {
        this._node = _reactDom.default.findDOMNode(ref);
        this.props.connectDropTarget(this._node);
        this._tree = ref;
        const {
          treeDnDForwardRef
        } = this.props;
        treeDnDForwardRef && treeDnDForwardRef(ref);
      });
      (0, _defineProperty2.default)(this, "_dragLayerRenderer", ({
        itemProps,
        currentOffset,
        droppable
      }) => /*#__PURE__*/_react.default.createElement(TreeDragLayer, {
        currentOffset: currentOffset,
        droppable: droppable
      }, this.props.dragLayerRenderer(itemProps, droppable)));
      (0, _defineProperty2.default)(this, "_itemRenderer", (node, props) => {
        const {
          itemRenderer,
          canDrop,
          onDrop,
          onItemHover
        } = this.props;
        const {
          draggingNodes
        } = this.state;
        const itemDragging = draggingNodes.indexOf(node) >= 0;
        const treeProps = { ...props,
          dragging: itemDragging,
          canDrop,
          onDrop,
          canDragNode: this._canDragNode,
          getDropProps: this._getDropProps,
          onBeginDrag: this._onBeginDrag,
          onEndDrag: this._onEndDrag,
          onHover: onItemHover
        };
        return itemRenderer(node, treeProps);
      });
      (0, _defineProperty2.default)(this, "_canDragNode", itemProps => {
        const {
          canDragNode
        } = this.props;
        const {
          node
        } = itemProps;

        const selected = this._tree.getSelectedNodes();

        return selected.indexOf(node) !== -1 && (!canDragNode || canDragNode(node));
      });
      (0, _defineProperty2.default)(this, "_onBeginDrag", itemProps => {
        const {
          data
        } = this.props;
        const {
          node
        } = itemProps;

        const selected = this._tree.getSelectedNodes();

        this.setState({
          draggingNodes: selected
        });
        const payload = {
          node,
          items: selected,
          dragLayerRenderer: this._dragLayerRenderer,
          data
        };
        let newPayload;

        if (this.props.onBeginDrag) {
          newPayload = this.props.onBeginDrag(payload);
        }

        return newPayload == null ? payload : newPayload;
      });
      (0, _defineProperty2.default)(this, "_onEndDrag", () => {
        setTimeout(() => {
          this.setState({
            draggingNodes: []
          });
          this.props.onEndDrag && this.props.onEndDrag();
        }, 0);
      });
    }

    _getDropProps({
      node,
      data,
      expanded,
      isAlwaysExpanded
    }, droppedY) {
      return {
        item: node,
        data,
        [typeof droppedY === 'boolean' ? 'droppedBelow' : 'droppedYPercent']: droppedY,
        expanded: expanded || isAlwaysExpanded
      };
    }

    render() {
      const {
        draggingNodes
      } = this.state;
      const {
        selectionMode,
        activeClassName,
        isActive,
        ...other
      } = this.props;
      const passThroughProps = omit(other, 'className', 'onDrop', 'canDrop', 'dragLayerRenderer', 'theme', 'connectDropTarget', 'onBeginDrag', 'canDragNode', 'onEndDrag', 'canFallThrough', 'onItemHover', 'getDragPosition', 'treeDnDForwardRef');
      let {
        className
      } = this.props;

      if (activeClassName && isActive()) {
        className = className ? `${className} ${activeClassName}` : activeClassName;
      }

      return /*#__PURE__*/_react.default.createElement(ScrollableTree, (0, _extends2.default)({
        fullHeight: true
      }, passThroughProps, {
        className: className,
        itemRenderer: this._itemRenderer,
        selectionMode: draggingNodes.length && selectionMode !== 'none' ? 'disabled' : selectionMode,
        isDragging: draggingNodes.length,
        ref: this._connectToDnD
      }));
    }

  }, (0, _defineProperty2.default)(_class2, "propTypes", {
    data: _propTypes.default.any.isRequired,
    dragLayerRenderer: _propTypes.default.func,
    canDrop: _propTypes.default.func,
    isActive: _propTypes.default.func,
    getDragPosition: _propTypes.default.func,
    onDrop: _propTypes.default.func,
    itemRenderer: _propTypes.default.func.isRequired,
    connectDropTarget: _propTypes.default.func.isRequired,
    theme: _propTypes.default.string,
    selectionMode: _propTypes.default.string,
    activeClassName: _propTypes.default.string,
    className: _propTypes.default.string,
    onEndDrag: _propTypes.default.func,
    onBeginDrag: _propTypes.default.func,
    canDragNode: _propTypes.default.func,
    onItemHover: _propTypes.default.func,
    canFallThrough: _propTypes.default.func,
    treeDnDForwardRef: _propTypes.default.func
  }), (0, _defineProperty2.default)(_class2, "defaultProps", {
    canFallThrough: () => false
  }), _temp)) || _class);
  return _react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(TreeDnD, (0, _extends2.default)({}, props, {
    treeDnDForwardRef: ref
  })));
}

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _ = _interopRequireDefault(__webpack_require__(587));

var _2 = _interopRequireDefault(__webpack_require__(588));

var _button = _interopRequireDefault(__webpack_require__(12));

var _list = __webpack_require__(22);

var _hspacer = _interopRequireDefault(__webpack_require__(91));

var _flexlayout = __webpack_require__(14);

var _utils = __webpack_require__(5);

var _TreeItem = _interopRequireDefault(__webpack_require__(589));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const treeItemClassName = _TreeItem.default.treeItemClassName.replace(/"/g, '');

const {
  omit
} = _utils.lodash;
const {
  stopEvent
} = _utils.event;

class TreeItem extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_onExpand", e => {
      stopEvent(e);
      const {
        onExpand,
        index,
        expanded
      } = this.props;
      onExpand && onExpand(index, !expanded);
    });
    (0, _defineProperty2.default)(this, "_stopPropagation", e => {
      e.stopPropagation();
    });
    (0, _defineProperty2.default)(this, "_onMenu", (x, y, e) => {
      const {
        onMenu
      } = this.props;
      onMenu && onMenu(x, y, e);
    });
  }

  render() {
    const {
      icon,
      depth,
      alwaysExpanded,
      hasChildren,
      expanded,
      children,
      onMenu,
      index,
      expandTitle,
      pathToRoot,
      isFocusNode,
      ...other
    } = this.props;
    let indent = icon ? 1 : 0;

    if (alwaysExpanded) {
      indent += 2;
    } else if (!hasChildren) {
      indent += 4;
    }

    if (depth != null) {
      indent += depth * 2;
    }

    const passThroughProps = omit(other, 'visible', 'node', 'getSelectedNodes', 'data', 'dragging', 'loading', 'onExpand', 'pathToRoot');
    return /*#__PURE__*/_react.default.createElement(_list.ListItem, (0, _extends2.default)({}, passThroughProps, {
      index: index,
      onMenu: onMenu && this._onMenu,
      className: `${treeItemClassName}`,
      role: "treeitem",
      "aria-expanded": hasChildren ? expanded : null,
      "data-tid": `treeItem${pathToRoot}`
    }), icon, indent > 0 ? /*#__PURE__*/_react.default.createElement(_hspacer.default, {
      size: indent
    }) : null, hasChildren && !alwaysExpanded || isFocusNode ? /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      hasIconOnly: true,
      kind: "ghost",
      size: "small",
      iconDescription: expandTitle // hidden via css
      ,
      "aria-label": expandTitle,
      onMouseDown: this._stopPropagation,
      onTouchEnd: this._stopPropagation,
      onDoubleClick: this._stopPropagation,
      onClick: this._onExpand,
      renderIcon: expanded ? _2.default : _.default,
      "data-tid": "expandTreeItemClickable"
    })) : null, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      grow: true,
      className: `${treeItemClassName}__child-item`
    }, children));
  }

}

exports.default = TreeItem;
(0, _defineProperty2.default)(TreeItem, "propTypes", {
  depth: _propTypes.default.number.isRequired,
  length: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired,
  icon: _propTypes.default.any,
  selected: _propTypes.default.bool,
  active: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  onMenu: _propTypes.default.func,
  alwaysExpanded: _propTypes.default.bool,
  expanded: _propTypes.default.bool,
  onExpand: _propTypes.default.func,
  hasChildren: _propTypes.default.bool,
  expandTitle: _propTypes.default.string,
  pathToRoot: _propTypes.default.string,
  ellipsisTitle: _propTypes.default.string,
  isFocusNode: _propTypes.default.bool
});
(0, _defineProperty2.default)(TreeItem, "defaultProps", {
  depth: 0
});

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

module.exports = require("@carbon/icons-react/lib/caret--right/16");

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

module.exports = require("@carbon/icons-react/lib/caret--down/16");

/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__90__;

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__91__;

/***/ })

},[[582,0]]]);
});